module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm2.82e5f0bc140e85c2c5f0499b698aca03.png";